import { Component, Input, OnInit, Output, EventEmitter, DestroyRef, inject, ChangeDetectorRef } from '@angular/core';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
import { TrafficsService } from '@app/services/traffics.service';
import { takeUntil } from 'rxjs/operators';
import { MediaService } from '@app/services/media.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-carrentextrafilters',
    templateUrl: './carrentextrafilters.component.html',
    styleUrls: ['./carrentextrafilters.component.scss'],
    standalone: false
})
export class CarrentextrafiltersComponent implements OnInit {
    @Input() mode: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

    showSmallMode: boolean = false;
    loading: boolean = false;
    filtersData: CarrentFilters;
    destroyRef = inject(DestroyRef);

    constructor(
        protected mediaService: MediaService,
        protected trafficsService: TrafficsService,
        protected cdr: ChangeDetectorRef,
        protected carrentFiltersService: CarrentFiltersService
    ) { }

    ngOnInit(): void {
        this.getFilters();
    }

    getFilters(): void {
        this.carrentFiltersService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(params => {
            if (params) {
                const tmp = JSON.parse(JSON.stringify(params));
                for (let i = 0; i < tmp?.filters?.opi?.filterList?.length; i++) {
                    if (tmp.filters.opi.filterList[i].code === 'FTI' || tmp.filters.opi.filterList[i].code === 'CFTI') {
                        tmp.filters.opi.filterList.splice(i, 1);
                        i--;
                    }

                }
                this.filtersData = tmp;
            }
            this.cdr.detectChanges();
        });
    }

    closeextras(): void {
        this.closeModal.emit(true);
    }

    async resetAll() {
        this.carrentFiltersService.resetAllExtrasHome();
    }

    setOpi(ev): void {
        this.carrentFiltersService.opiResult(ev, this.mode === 'home');
    }

    setFkl(ev): void {
        this.carrentFiltersService.fklResult(ev, this.mode === 'home');
    }

    setPkt(ev): void {
        this.carrentFiltersService.pktResult(ev, this.mode === 'home');
    }

    setFty(ev): void {
        this.carrentFiltersService.ftyResult(ev, this.mode === 'home');
    }

    setInc(ev): void {
        this.carrentFiltersService.incResult(ev, this.mode === 'home');
    }

    setIns(ev): void {
        this.carrentFiltersService.insResult(ev, this.mode === 'home');
    }

    setTrg(ev): void {
        this.carrentFiltersService.trgResult(ev, this.mode === 'home');
    }
}
